/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaB2CCartData } from './aaa_b2c_cart.data';
import { IAaa_b2c_cartProps } from './aaa_b2c_cart.props.autogenerated';
import {
    createRequestOrderAsync,
    deleteB2CCartByBMASnapshotIdAsync,
    getB2BCustomerIdAsync,
    getB2CCartServiceAsync
} from '../../dataActions/DataActionExtension.g';
import {
    FullProductInput,
    getFallbackImageUrl,
    getFullProducts,
    getProductDetailsCriteriaFromActionInput
} from '@msdyn365-commerce-modules/retail-actions';
import axios from 'axios';
export interface IAaa_b2c_cartViewProps extends IAaa_b2c_cartProps<IAaaB2CCartData> {
    cartItems: any;
    removeFromCart: any;
    cartTotalPrice: any;
    submitOrder: any;
    isLoading: boolean;
    jwellerInfo: any;
}

/**
 *
 * Aaa_b2c_cart component
 * @extends {React.PureComponent<IAaa_b2c_cartProps<IAaaB2CCartData>>}
 */
class Aaa_b2c_cart extends React.PureComponent<IAaa_b2c_cartProps<IAaaB2CCartData>, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            cartItems: [],
            cartTotalPrice: undefined,
            isLoading: true,
            jwellerInfo: undefined,
            translationInfo: undefined
        };
    }

    public async componentDidMount(): Promise<void> {
        await this.getCartItemList();
    }

    public getCartItemList = async () => {
        const cartResult: any = await getB2CCartServiceAsync({ callerContext: this.props.context.actionContext, queryResultSettings: {} });
        if (cartResult.B2CCart) {
            if (cartResult.B2CCart.length > 0) {
                await this.getTranslationInfo();
            }
            const productInputs: any = [];
            const customerInfo = this.props.context.actionContext.requestContext.user;
            cartResult.B2CCart.map((cartItem: any) => {
                if (cartItem.ProductId && cartItem.BMASnapshotId) {
                    productInputs.push(
                        new FullProductInput(
                            cartItem.ProductId,
                            this.props.context.actionContext.requestContext.apiSettings,
                            getProductDetailsCriteriaFromActionInput(this.props.context.actionContext)
                        )
                    );
                }
            });
            if (productInputs.length > 0) {
                return getFullProducts(productInputs, this.props.context.actionContext).then(async products => {
                    if (products) {
                        await this.mappedCartItems(cartResult.B2CCart, products, customerInfo);
                    } else {
                        this.setState({ cartItems: [], isLoading: false, cartTotalPrice: undefined, jwellerInfo: undefined });
                    }
                });
            } else {
                this.setState({ cartItems: [], isLoading: false, cartTotalPrice: undefined, jwellerInfo: undefined });
            }
        }
    };

    public getTranslationInfo = async () => {
        let translationInfo = await axios.get(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaTranslationMessageEndPoint}`);
        translationInfo = translationInfo.data;
        this.setState({ translationInfo });
    };

    public removeFromCart = async (snapshotId: string, recId: number) => {
        await deleteB2CCartByBMASnapshotIdAsync(
            { callerContext: this.props.context.actionContext, queryResultSettings: {} },
            snapshotId,
            recId
        ).then(response => {
            window.location.reload();
        });
    };
    public submitOrder = async () => {
        const { context } = this.props;
        const customerInfo: any = context.actionContext.requestContext.user;

        const b2bCustomer: any = await getB2BCustomerIdAsync(
            { callerContext: this.props.context.actionContext, queryResultSettings: {} },
            customerInfo ? customerInfo.customerAccountNumber : ''
        );
        const addProductsOrderRequest: any = [];
        this.state.cartItems.forEach((item: any) => {
            const addProductToOrderRequest: any = {
                B2CCustomerId:
                    customerInfo && !customerInfo.isB2b && customerInfo.customerAccountNumber ? customerInfo.customerAccountNumber : '',
                B2BCustomerId: b2bCustomer.B2BCustomerId,
                Quantity: 1,
                ProductId: item.ProductDetails.RecordId,
                UnitOfMeasure: item.ProductDetails.DefaultUnitOfMeasure,
                Snapshotid: item.snapShotId ? item.snapShotId : '',
                ExtensionProperties: item.ProductDetails.ExtensionProperties,
                B2BPrice: customerInfo && customerInfo.isB2b && item.price.AdjustedPrice ? item.price.AdjustedPrice : 0,
                B2CPrice: customerInfo && !customerInfo.isB2b && item.price.AdjustedPrice ? item.price.AdjustedPrice : 0,
                ItemId: item.ProductDetails.ItemId
            };
            addProductsOrderRequest.push(addProductToOrderRequest);
        });

        if (context && addProductsOrderRequest.length > 0) {
            const requestOrderResponse = await createRequestOrderAsync(
                { callerContext: this.props.context.actionContext },
                addProductsOrderRequest
            );
            if (requestOrderResponse) {
                const request = this.props.context.request;
                let orderConfirmUrl = request.url.requestUrl.origin;
                if (request.sitePath) {
                    orderConfirmUrl = orderConfirmUrl + request.sitePath;
                }
                window.location.href = `${orderConfirmUrl}${this.props.config.redirectToOrderConfirmUrl}?requestOrderId=${requestOrderResponse.RequestOrderId}`;
            }
        }
        console.log(addProductsOrderRequest);
    };

    public async mappedCartItems(items: any, products: any, customerInfo: any) {
        const cartItems: any = [];
        const jwellerInfo = await getB2BCustomerIdAsync(
            { callerContext: this.props.context.actionContext },
            customerInfo.customerAccountNumber
        );
        let cartTotalPriceAmount = 0;
        const cartTotalPrice: any = {};
        for (const [index, cartItem] of items.entries()) {
            const product: any = products.find((p: any) => {
                return cartItem.ProductId === p.ProductDetails.RecordId;
            });
            if (product && cartItem.ProductId && cartItem.BMASnapshotId && this.state.translationInfo) {
                if (!cartItem.BMASnapshotId) {
                    product.key = `Non BMA Product ${index}`;
                    cartItems.push(product);
                } else {
                    const bmaReviewEndPoint = this.props.app.config.bmaReviewEndPoint.replace('#snapshotId', cartItem.BMASnapshotId);
                    const review = await axios.get(`${this.props.app.config.bmaBaseUrl}${bmaReviewEndPoint}`);

                    let bmaPriceEndPoint = this.props.app.config.bmaPriceEndPoint.replace('#snapshotId', cartItem.BMASnapshotId);
                    bmaPriceEndPoint = bmaPriceEndPoint.replace('#jewellerId', jwellerInfo.BMARetailStockist);
                    const price = await axios.get(`${this.props.app.config.bmaBaseUrl}${bmaPriceEndPoint}`);

                    const bmaImageEndPoint = this.props.app.config.bmaImageEndPoint.replace('#snapshotId', cartItem.BMASnapshotId);
                    const ringImage: any = await axios.get(`${this.props.app.config.bmaBaseUrl}${bmaImageEndPoint}`);

                    const ringsInfo = price.data.rings;
                    const productInfo: any = { ...product };
                    const productDetails: any = { ...product.ProductDetails };
                    productDetails.PrimaryImageUrl = ringImage.data[0];
                    productInfo.ProductDetails = productDetails;
                    productInfo.snapShotId = cartItem.BMASnapshotId;
                    productInfo.key = cartItem.BMASnapshotId;
                    productInfo.review = review.data;
                    productInfo.recId = cartItem.RecId;
                    productInfo.fallbackImage = getFallbackImageUrl(
                        product.ProductDetails.ItemId,
                        this.props.context.actionContext.requestContext.apiSettings
                    );
                    productInfo.rings = [];
                    productInfo.totalPrice = price.data.sum.vk;
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    cartTotalPriceAmount = cartTotalPriceAmount + price.data.sum.vk;
                    const productTotalPrice = { ...product.ProductPrice };
                    productTotalPrice.AdjustedPrice = productInfo.totalPrice;
                    productTotalPrice.BasePrice = productInfo.totalPrice;
                    productTotalPrice.CustomerContextualPrice = productInfo.totalPrice;
                    productTotalPrice.TradeAgreementPrice = productInfo.totalPrice;
                    productInfo.price = productTotalPrice;
                    for (const ring of ringsInfo) {
                        const ringReview = productInfo.review.find((r: any) => {
                            return r.ringId === ring.id;
                        });
                        let height = '5mm';
                        let width = '1.4mm';
                        if (ringReview.properties && ringReview.properties.profile) {
                            if (ringReview.properties.profile.width) {
                                width = `${ringReview.properties.profile.width.value} ${ringReview.properties.profile.width.type}`;
                            }
                            if (ringReview.properties.profile.height) {
                                height = `${ringReview.properties.profile.height.value} ${ringReview.properties.profile.height.type}`;
                            }
                        }
                        let diamondCount = null;
                        diamondCount =
                            ringReview.properties.stone.preset.length > 0 &&
                            ringReview.properties.stone.preset[0].id !== 'none' &&
                            ringReview.properties.stone.quantity.reduce(function(sum: any, current: any) {
                                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                                return sum + current.count;
                            }, 0);
                        const ringSizePi = ringReview.properties.ring.size.value / 3.14159265;
                        const ringInfo: any = {
                            ringId: ring.id,
                            ringName: ringReview.name,
                            alloy: `${this.state.translationInfo[ringReview.properties.disc.fineness[0].label]}
                                ${''}${this.state.translationInfo[ringReview.properties.disc.color[0].label]}`,
                            sizeLabel: ringReview.properties.ring.size.label,
                            sizeValue:
                                Math.round(
                                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                                    (ringSizePi + Number.EPSILON) * 100
                                ) / 100,
                            specifications: diamondCount
                                ? `${diamondCount} Diamonds, ${width} Wide, ${height} thick`
                                : `${width} Wide, ${height} thick`
                        };
                        const productPrice = { ...product.ProductPrice };
                        productPrice.AdjustedPrice = ring.vk;
                        productPrice.BasePrice = ring.vk;
                        productPrice.CustomerContextualPrice = ring.vk;
                        productPrice.TradeAgreementPrice = ring.vk;
                        ringInfo.price = productPrice;
                        productInfo.rings.push(ringInfo);
                        const totalPrice = { ...product.ProductPrice };
                        totalPrice.AdjustedPrice = cartTotalPriceAmount;
                        totalPrice.BasePrice = cartTotalPriceAmount;
                        totalPrice.CustomerContextualPrice = cartTotalPriceAmount;
                        totalPrice.TradeAgreementPrice = cartTotalPriceAmount;
                        cartTotalPrice.price = totalPrice;
                    }
                    cartItems.push(productInfo);
                }
            }
        }

        this.setState({ cartItems, cartTotalPrice, isLoading: false, jwellerInfo: jwellerInfo });
    }

    public render(): JSX.Element | null {
        const viewProps: IAaa_b2c_cartViewProps = {
            ...(this.props as IAaa_b2c_cartProps<IAaaB2CCartData>),
            cartItems: this.state.cartItems,
            removeFromCart: this.removeFromCart,
            cartTotalPrice: this.state.cartTotalPrice,
            submitOrder: this.submitOrder,
            isLoading: this.state.isLoading,
            jwellerInfo: this.state.jwellerInfo
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Aaa_b2c_cart;
